<template>
  <div class="full-height full-width row">
    <q-drawer
      v-model="state.left.show"
      :mini="!state.left.show || state.left.miniState"
      :width="220"
      :breakpoint="500"
      bordered
      content-class="bg-white column"
    >
      <q-scroll-area class="col">
        <q-list padding>
          <q-item v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label>Template OCR</q-item-label>
              <q-item-label caption style="padding-bottom:8px">
                손쉽게 템플릿을 만들고 원하는 영역을 지정한 뒤, 필요한 글자만 빠르게 추출하는 기능을 제공합니다.
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-separator v-show="state.left.miniState == false" />
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="settings" />
            </q-item-section>

            <q-item-section>
              설정
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">설정</q-tooltip>
          </q-item>

          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="app_settings_alt" />
            </q-item-section>

            <q-item-section>
              배포 관리
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">배포 관리</q-tooltip>
          </q-item>
          <q-separator />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                템플릿 설정
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item :active="state.page.value == 'template-list-view'" clickable v-ripple @click="state.page.value = 'template-list-view'">
            <q-item-section avatar>
              <q-icon name="list_alt" />
            </q-item-section>

            <q-item-section>
              템플릿 목록
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">템플릿 목록</q-tooltip>
          </q-item>

          <q-separator />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                테스트 및 분석
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item :active="state.page.value == 'test-view'" clickable v-ripple @click="state.page.value = 'test-view'">
            <q-item-section avatar>
              <q-icon name="video_library" />
            </q-item-section>

            <q-item-section>
              테스트
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">테스트</q-tooltip>
          </q-item>
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="insights" />
            </q-item-section>

            <q-item-section>
              통합 지표
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">통합 지표</q-tooltip>
          </q-item>
          <q-separator />
          <q-item dense v-show="state.left.miniState == false">
            <q-item-section>
              <q-item-label caption>
                콤포넌트
              </q-item-label>
            </q-item-section>
          </q-item>
          <q-item clickable v-ripple disable>
            <q-item-section avatar>
              <q-icon name="book" />
            </q-item-section>

            <q-item-section>
              용어사전
            </q-item-section>

            <q-tooltip v-if="state.left.miniState == true" :offset="[8, 0]">용어 사전</q-tooltip>
          </q-item>
        </q-list>
      </q-scroll-area>
      <q-separator />
      <q-item clickable v-ripple @click="state.left.miniState = !state.left.miniState">
        <q-item-section avatar>
          <q-icon v-if="state.left.miniState == false" name="chevron_left" />
          <q-icon v-else name="chevron_right" />
        </q-item-section>

        <q-item-section style="color:rgb(125, 125, 125);font-size:12px;">
          POWERED BY SELVAS AI
        </q-item-section>
      </q-item>
    </q-drawer>

    <q-page-container class="column col full-height full-width">
      <q-page class="column col full-height full-width" style="background:rgb(237, 238, 242);padding:10px 25px;overflow:auto;">
        <template-list-view v-if="state.page.value == 'template-list-view'" />
        <test-view v-if="state.page.value == 'test-view'" />
      </q-page>
    </q-page-container>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import TemplateListView from '@/projects/template_ocr/views/TemplateListView.vue'
import TestView from '@/projects/template_ocr/views/TestView.vue'

export default {
  name: 'App',
  data: function () {
    return {
      state: {
        left: {
          show: true,
          miniState: false
        },
        page: {
          value: 'template-list-view'
        }
      }
    }
  },
  components: {
     TemplateListView,
     TestView
  },
  methods: {
    doubleRaf: function (callback) {
      requestAnimationFrame(() => {
        requestAnimationFrame(callback)
      })
    }
  }
}
</script>

<style>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin: 0;
  overflow: auto;
  background: rgb(239, 239, 239);
}

.body {
  display:flex;
  flex-direction:column;
  height:100%;
  width:100%;
  background: rgb(237, 238, 241);
}

.q-toggle__thumb {
  color: red !important;
}

.q-toggle__thumb:after {
  background: rgb(230, 230, 230) !important;
}

.q-toggle__inner--indet .q-toggle__thumb:after {
  background: rgb(3, 169, 244) !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background: #027BE3 !important;
}

.q-toggle__inner.q-toggle__inner--indet {
  color:rgb(41, 182, 246);
}

::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 6px;
  height: 6px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}

</style>
